/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../../types/schema.generated';

import gql from 'graphql-tag';
export type SegmentFormFragment = { segmentConditionParameters: { enqueteAnsweredCondition: { enquetes: Array<{ guid: string, title: string }> }, inflowSourceCondition: { inflowSources: Array<{ guid: string, inflowSourceName: string }> }, clickURLCondition: { clickUrls: Array<{ guid: string, url: string }> }, userVariableDefinitionCondition: { userVariableDefinitions: Array<{ guid: string, name: string, value:
          | { __typename: 'UserVariableDefinitionValueMultipleSelect', options: Array<{ guid: string, name: string }> }
          | { __typename: 'UserVariableDefinitionValueSelect', options: Array<{ guid: string, name: string }> }
          | Record<PropertyKey, never>
         }> } } };

export const SegmentFormFragmentDoc = gql`
    fragment SegmentForm on Query {
  segmentConditionParameters {
    enqueteAnsweredCondition {
      enquetes {
        guid
        title
      }
    }
    inflowSourceCondition {
      inflowSources {
        guid
        inflowSourceName
      }
    }
    clickURLCondition {
      clickUrls {
        guid
        url
      }
    }
    userVariableDefinitionCondition {
      userVariableDefinitions {
        guid
        name
        value {
          ... on UserVariableDefinitionValueSelect {
            __typename
            options {
              guid
              name
            }
          }
          ... on UserVariableDefinitionValueMultipleSelect {
            __typename
            options {
              guid
              name
            }
          }
        }
      }
    }
  }
}
    `;